<template>
  <div class="paiement-container">
    <div v-if="load == true">
      <!-- BANDEAU SOLDE + ACTIONS -->
      <div class="solde-banner">
        <div class="solde-banner-left">
          <span class="solde-banner-label">SOLDE</span>
          <span
            :class="[
              'solde-montant-val',
              solde >= 0 ? 'solde-pos' : 'solde-neg',
            ]"
            >{{ solde }} €</span
          >
        </div>

        <div
          class="solde-banner-actions"
          v-if="this.$store.state.user.role.label !== 'eleve'"
        >
          <!-- Bouton paiement -->
          <button
            class="solde-action-btn solde-action-pay"
            @click="showPopupPaiement()"
          >
            <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
              <path
                d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Nouveau paiement
          </button>

          <!-- Bouton Dossier -->
          <template v-if="this.data.statutDossier != 'Enregistrer'">
            <div class="tooltip-container">
              <button
                v-if="dossier.ok == 0"
                class="solde-action-btn solde-action-dossier"
                @click="checkDossier()"
                :disabled="this.dossier.mode"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                Dossier
              </button>
              <button
                v-if="dossier.ok == 1"
                class="solde-action-btn solde-action-dossier dossier-warning"
                @click="checkDossier()"
                :disabled="this.dossier.mode"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                Dossier
              </button>
              <button
                v-if="dossier.ok == 2"
                class="solde-action-btn solde-action-dossier dossier-success"
                @click="checkDossier()"
                disabled
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                Dossier
              </button>

              <div class="tooltip-div">
                <div class="btnColor">
                  <div class="squareColorPrimary"></div>
                  <p>
                    : Cliquer si l'élève demande la prestation pour le dossier.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorWarning"></div>
                  <p>
                    : Annulable si l'élève n'a pas commencé à insérer des pièces
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorSuccess"></div>
                  <p>
                    : Non annulable si l'élève a commencé à insérer des pièces.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorInfo"></div>
                  <p>: Dossier Enregistré</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tooltip-container">
              <button
                class="solde-action-btn solde-action-dossier dossier-info"
                @click="checkDossier()"
                disabled
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  />
                </svg>
                Dossier
              </button>
              <div class="tooltip-div">
                <div class="btnColor">
                  <div class="squareColorPrimary"></div>
                  <p>
                    : Cliquer si l'élève demande la prestation pour le dossier.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorWarning"></div>
                  <p>
                    : Annulable si l'élève n'a pas commencé à insérer des pièces
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorSuccess"></div>
                  <p>
                    : Non annulable si l'élève a commencé à insérer des pièces.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorInfo"></div>
                  <p>: Dossier Enregistré</p>
                </div>
              </div>
            </div>
          </template>

          <!-- Bouton Code -->
          <template v-if="this.data.code == 'Obtenu'">
            <div class="tooltip-container">
              <button
                class="solde-action-btn solde-action-code code-info"
                @click="checkCode()"
                disabled
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                </svg>
                Code
              </button>
              <div class="tooltip-div">
                <div class="btnColor">
                  <div class="squareColorPrimary"></div>
                  <p>: Cliquer si l'élève demande la prestation code.</p>
                </div>
                <div class="btnColor">
                  <div class="squareColorWarning"></div>
                  <p>
                    : Annulable si l'élève n'a pas encore reçu le livre de code
                    ou l'accès à PrepaCode
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorSuccess"></div>
                  <p>
                    : Non annulable si l'élève a reçu son livre de code ou son
                    accès PrepaCode.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorInfo"></div>
                  <p>: Code obtenu</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="tooltip-container">
              <button
                v-if="code.ok == 0"
                class="solde-action-btn solde-action-code"
                @click="checkCode()"
                :disabled="this.code.mode"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                </svg>
                Code
              </button>
              <button
                v-if="code.ok == 1"
                class="solde-action-btn solde-action-code code-warning"
                @click="checkCode()"
                :disabled="this.code.mode"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                </svg>
                Code
              </button>
              <button
                v-if="code.ok == 2"
                class="solde-action-btn solde-action-code code-success"
                @click="checkCode()"
                disabled
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                </svg>
                Code
              </button>
              <div class="tooltip-div">
                <div class="btnColor">
                  <div class="squareColorPrimary"></div>
                  <p>: Cliquer si l'élève demande la prestation code.</p>
                </div>
                <div class="btnColor">
                  <div class="squareColorWarning"></div>
                  <p>
                    : Annulable si l'élève n'a pas encore reçu le livre de code
                    ou l'accès à PrepaCode
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorSuccess"></div>
                  <p>
                    : Non annulable si l'élève a reçu son livre de code ou son
                    accès PrepaCode.
                  </p>
                </div>
                <div class="btnColor">
                  <div class="squareColorInfo"></div>
                  <p>: Code obtenu</p>
                </div>
              </div>
            </div>
          </template>

          <!-- Boutons CPF / PE / SUBV -->
          <button
            v-if="droitCpf.length != 0"
            @click="showCpfDetail()"
            class="solde-action-btn solde-action-cpf"
          >
            CPF
          </button>
          <button
            v-if="droitPe.length != 0"
            @click="showPeDetail()"
            class="solde-action-btn solde-action-cpf"
          >
            PE
          </button>
          <button
            v-if="droitSubv.length != 0"
            @click="showSubvDetail()"
            class="solde-action-btn solde-action-cpf"
          >
            SUBV
          </button>
        </div>
      </div>

      <!-- TABLEAU DES PAIEMENTS -->
      <div :class="this.modal ? 'table-wrap table-wrap--modal' : 'table-wrap'">
        <table id="paiement">
          <thead>
            <tr class="solde-thead">
              <th class="solde-th">
                <span class="solde-th-icon">
                  <template v-if="sortDateValue">
                    <button class="btn-sort" @click="sortDate()">
                      Date
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 5v14M5 12l7-7 7 7"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </template>
                  <template v-if="!sortDateValue">
                    <button class="btn-sort" @click="sortDate()">
                      Date
                      <svg
                        width="10"
                        height="10"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 19V5M19 12l-7 7-7-7"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </template>
                </span>
              </th>
              <th class="solde-th">
                <span class="solde-th-icon">
                  <select
                    class="select-th"
                    name="nature"
                    id="nature"
                    v-model="tabPaiement.nature"
                    @change="changeNature()"
                  >
                    <option value="">Nature</option>
                    <option value="Droits CPF">Droits CPF</option>
                    <option value="Droits PE">Droits PE</option>
                    <option value="Droits SUBV">Droits SUBV</option>
                    <option value="Acpte CPF">Acpte CPF</option>
                    <option value="Acpte PE">Acpte PE</option>
                    <option value="Acpte SUBV">Acpte SUBV</option>
                    <option value="dossier">Dossier</option>
                    <option value="code">Code</option>
                    <option value="Paiement">Paiement</option>
                    <option value="conduite">Conduite</option>
                  </select>
                  <svg width="10" height="10" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </th>
              <th class="solde-th">C</th>
              <th class="solde-th">D</th>
              <th class="solde-th">
                <span class="solde-th-icon">
                  <select
                    class="select-th"
                    name="modes"
                    id="modes"
                    v-model="tabPaiement.mode"
                    @change="changeMode()"
                  >
                    <option value="">Mode</option>
                    <option value="CB">CB</option>
                    <option value="VIR">VIR</option>
                    <option value="PE">PE</option>
                    <option value="SUBV">SUBV</option>
                    <option value="CPF">CPF</option>
                    <option value="CB WEB">CB WEB</option>
                  </select>
                  <svg width="10" height="10" fill="none" viewBox="0 0 24 24">
                    <path
                      d="M6 9l6 6 6-6"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="paiement in paiements"
              :key="paiement.id"
              :id="paiement.id"
              @click="editPaiement(paiement.id)"
            >
              <td
                class="solde-td date-col"
                v-if="
                  new Date(paiement.date.date).toLocaleDateString('fr-FR') !=
                  'Invalid Date'
                "
              >
                {{ new Date(paiement.date.date).toLocaleDateString('fr-FR') }}
              </td>
              <td
                class="solde-td date-col"
                v-if="
                  new Date(paiement.date.date).toLocaleDateString('fr-FR') ==
                  'Invalid Date'
                "
              >
                {{ paiement.date }}
              </td>
              <td class="solde-td">{{ paiement.description }}</td>

              <template
                v-if="paiement.mode != 'CB WEB' && paiement.mode != 'T'"
              >
                <template v-if="paiement.description == 'code'">
                  <td class="solde-td"></td>
                  <td class="solde-td solde-debit">{{ paiement.tot }}</td>
                </template>
                <template v-else-if="paiement.description == 'permis accéléré'">
                  <td class="solde-td"></td>
                  <td class="solde-td solde-debit">{{ paiement.tot }}</td>
                </template>
                <template v-else-if="paiement.description == 'exam'">
                  <td class="solde-td"></td>
                  <td class="solde-td solde-debit">{{ paiement.tot }}</td>
                </template>
                <template v-else-if="paiement.description == 'exam blanc'">
                  <td class="solde-td"></td>
                  <td class="solde-td solde-debit">{{ paiement.tot }}</td>
                </template>
                <template v-else-if="paiement.description == 'dossier'">
                  <td class="solde-td"></td>
                  <td class="solde-td solde-debit">{{ paiement.tot }}</td>
                </template>
                <template v-else>
                  <td class="solde-td solde-credit">{{ paiement.tot }}</td>
                  <td class="solde-td"></td>
                </template>
              </template>
              <template v-else-if="paiement.description == 'Transfert Solde'">
                <td class="solde-td solde-credit">{{ paiement.tot }}</td>
                <td class="solde-td"></td>
              </template>
              <template v-else>
                <td class="solde-td solde-credit">{{ paiement.tot }}</td>
                <td class="solde-td solde-debit">{{ paiement.tot }}</td>
              </template>
              <template></template>

              <template
                v-if="
                  (paiement.description == 'dossier' && paiement.mode != 'T') ||
                  (paiement.description == 'code' && paiement.mode != 'T') ||
                  (paiement.description == 'permis accéléré' &&
                    paiement.mode != 'T')
                "
              >
                <td class="solde-td"></td>
              </template>
              <template v-else>
                <td class="solde-td">
                  <span v-if="paiement.mode" class="mode-badge">{{
                    paiement.mode
                  }}</span>
                </td>
              </template>
            </tr>

            <!-- Ligne CONDUITE -->
            <tr class="row-conduite">
              <td class="solde-td date-col">CONDUITE</td>
              <td class="solde-td">CONDUITE</td>
              <td class="solde-td"></td>
              <td class="solde-td solde-debit">{{ this.rdvSolde }}</td>
              <td class="solde-td"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- DIALOG PAIEMENT (PrimeVue) -->
      <Dialog
        v-model:visible="popupPaiement"
        modal
        header="PAIEMENT"
        :style="{ width: '600px' }"
      >
        <div class="modal-grid">
          <div class="pay-modal-field">
            <label class="pay-modal-label">Date Paiement</label>
            <input
              class="pay-modal-input"
              type="date"
              name="date"
              id="date"
              v-model="postPaiement.date"
            />
          </div>

          <div class="pay-modal-field" v-if="postPaiement.id == ''">
            <label class="pay-modal-label">Montant</label>
            <input
              class="pay-modal-input"
              type="number"
              name="price"
              id="price"
              v-model="postPaiement.price"
            />
          </div>
          <div class="pay-modal-field" v-if="postPaiement.id != ''">
            <label class="pay-modal-label">Montant</label>
            <input
              class="pay-modal-input"
              type="number"
              name="price"
              id="price"
              v-model="postPaiement.price"
              disabled
            />
          </div>

          <div class="pay-modal-field">
            <label class="pay-modal-label">Mode de paiement</label>
            <select
              class="pay-modal-select"
              name="mode"
              id="mode"
              v-model="postPaiement.mode"
              @change="changeSelect()"
            >
              <option value="" disabled>Mode de paiement</option>
              <option value="CB">CB</option>
              <option value="VIR">VIR</option>
              <option value="PE">PE</option>
              <option value="SUBV">SUBV</option>
              <option value="CPF">CPF</option>
            </select>
          </div>

          <div class="pay-modal-field" v-if="step == 1">
            <label class="pay-modal-label">Payeur</label>
            <select
              class="pay-modal-select"
              name="payeur"
              id="payeur"
              v-model="postPaiement.payeur"
            >
              <option value="" disabled>Payeur</option>
              <option value="client">client</option>
            </select>
          </div>

          <div class="pay-modal-field" v-if="step == 2">
            <label class="pay-modal-label">Payeur</label>
            <select
              class="pay-modal-select"
              name="payeur"
              id="payeur"
              v-model="postPaiement.payeur"
            >
              <option value="" disabled>Payeur</option>
              <option value="client">client</option>
              <option value="CPF">CPF</option>
              <option value="SUBV">SUBV</option>
              <option value="PE">PE</option>
            </select>
          </div>

          <div class="pay-modal-field" v-if="step == 3">
            <label class="pay-modal-label">Numéro</label>
            <input
              class="pay-modal-input"
              type="text"
              name="payeur"
              id="payeur"
              v-model="postPaiement.payeur"
            />
          </div>

          <div
            class="pay-modal-field"
            v-if="postPaiement.mode == 'VIR' && postPaiement.payeur == 'CPF'"
          >
            <label class="pay-modal-label">Droit CPF</label>
            <select
              class="pay-modal-select"
              name="choice"
              id="choice"
              v-model="postPaiement.choix"
            >
              <option value="" disabled>Droit CPF</option>
              <template v-for="droit in droitCpf" :key="droit.id">
                <option :value="droit.id">{{ droit.payeur }}</option>
              </template>
            </select>
          </div>

          <div
            class="pay-modal-field"
            v-if="postPaiement.mode == 'VIR' && postPaiement.payeur == 'PE'"
          >
            <label class="pay-modal-label">Droit PE</label>
            <select
              class="pay-modal-select"
              name="choice"
              id="choice"
              v-model="postPaiement.choix"
            >
              <option value="" disabled>Droit PE</option>
              <template v-for="droit in droitPe" :key="droit.id">
                <option :value="droit.id">{{ droit.payeur }}</option>
              </template>
            </select>
          </div>

          <div
            class="pay-modal-field"
            v-if="postPaiement.mode == 'VIR' && postPaiement.payeur == 'SUBV'"
          >
            <label class="pay-modal-label">Droit SUBV</label>
            <select
              class="pay-modal-select"
              name="choice"
              id="choice"
              v-model="postPaiement.choix"
            >
              <option value="" disabled>Droit SUBV</option>
              <template v-for="droit in droitSubv" :key="droit.id">
                <option :value="droit.id">{{ droit.payeur }}</option>
              </template>
            </select>
          </div>
        </div>

        <template #footer>
          <div class="modal-footer-btns">
            <template v-if="postPaiement.id == ''">
              <button
                class="btn-pay-modal"
                @click="postPaiements()"
                v-if="!loadBtnPaiement"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M9 12l2 2 4-4"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                OK — PAIEMENT RÉALISÉ
              </button>
              <button
                class="btn-pay-modal"
                @click="postPaiements()"
                v-else
                disabled
              >
                <span><i class="fa fa-spinner fa-spin"></i>OK — PAIEMENT RÉALISÉ</span>
              </button>
            </template>
            <template v-if="postPaiement.id != ''">
              <button
                class="btn-pay-modal btn-pay-edit"
                @click="putPaiements()"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                MODIFIER
              </button>
              <button
                class="btn-pay-modal btn-pay-delete"
                @click="deletePaiements()"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                SUPPRIMER
              </button>
            </template>

          </div>
        </template>
      </Dialog>

      <template v-if="showCpf">
        <CpfPopup
          @cancelCpfDetail="cancelCpfDetail($event)"
          :boolean="showCpf"
          :droitCpf="droitCpf"
          :acpteCpf="acpteCpf"
        />
      </template>
      <template v-if="showPe">
        <PePopup
          @cancelPeDetail="cancelPeDetail($event)"
          :boolean="showPe"
          :droitPe="droitPe"
          :acptePe="acptePe"
        />
      </template>
      <template v-if="showSubv">
        <SubvPopup
          @cancelSubvDetail="cancelSubvDetail($event)"
          :boolean="showSubv"
          :droitSubv="droitSubv"
          :acpteSubv="acpteSubv"
        />
      </template>
    </div>
    <div v-else class="loading-state">
      <div class="loading-spinner"></div>
      <p>Chargement…</p>
    </div>
  </div>
</template>

<script>
import CpfPopup from "../eleve/paiementComp/CpfPopup.vue";
import PePopup from "../eleve/paiementComp/PePopup.vue";
import SubvPopup from "../eleve/paiementComp/SubvPopup.vue";

export default {
  props: ["data", "modal"],

  components: {
    CpfPopup,
    PePopup,
    SubvPopup,
  },

  data() {
    return {
      load: false,
      showTitleBtnDoss: false,
      popupPaiement: false,
      dossier: [],
      code: [],
      conduite: [],

      droitCpf: [],
      droitPe: [],
      droitSubv: [],

      acpteCpf: [],
      acptePe: [],
      acpteSubv: [],

      allPaiements: [],
      paiements: [],

      postPaiement: {
        id: "",
        date: "",
        price: 0,
        mode: "",
        payeur: "",
        choix: "",
        montantEdit: 0,
      },

      tabPaiement: {
        date: false,
        nature: "",
        mode: "",
      },

      fonc: {
        code: false,
        dossier: false,
        conduite: false,
      },
      step: 1,
      sortDateValue: false,

      solde: 0,
      rdvSolde: 0,
      showCpf: false,
      showPe: false,
      showSubv: false,
      loadBtnPaiement : false,
    };
  },

  beforeMount() {},

  mounted() {
    this.checkPaiement();
  },

  methods: {
    changeSoldePlanning(montant) {
      let soldeBtn = this.solde + montant;
      const btnSolde = document.getElementById("btnSolde");
      if (btnSolde != null) {
        const valueEl = btnSolde.querySelector(".solde-card-value");
        if (valueEl != null) {
          valueEl.textContent = Number(soldeBtn).toLocaleString('fr-FR') + " €";
        }
      }
    },

    deletePaiements() {
      window.api
        .patch(
          "/other_paiements/" + this.postPaiement.id,
          { archive: true },
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
              "Content-Type": "application/merge-patch+json",
            },
          },
        )
        .then(() => {
          this.checkPaiement();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editPaiement(id) {
      if (this.$store.state.user.role.label !== "eleve") {
        this.postPaiement.date = "";
        this.postPaiement.price = 0;
        this.postPaiement.mode = "";
        this.postPaiement.payeur = "";
        this.postPaiement.id = "";
        this.postPaiement.montantEdit = 0;
        this.step = 1;

        let paiement = [];
        paiement = this.allPaiements.find((p) => p.id == id);
        if (
          paiement.mode != "CB WEB" &&
          paiement.description != "code" &&
          paiement.description != "dossier"
        ) {
          if (paiement.mode == "ESP" || paiement.mode == "CB") {
            this.step = 1;
            this.payeur = "client";
          } else if (paiement.mode == "CHQ" || paiement.mode == "VIR") {
            this.step = 2;
          } else if (
            paiement.mode == "CPF" ||
            paiement.mode == "SUBV" ||
            paiement.mode == "PE"
          ) {
            this.step = 3;
          }

          this.postPaiement.date = new Date(
            paiement.date.date,
          ).toLocaleDateString('fr-FR');
          this.postPaiement.price = paiement.tot;
          this.postPaiement.montantEdit = paiement.tot;
          this.postPaiement.mode = paiement.mode;
          this.postPaiement.payeur = paiement.payeur;
          this.postPaiement.id = id;

          this.popupPaiement = true;
        }
      }
    },

    showSubvDetail() {
      this.showSubv = true;
    },
    cancelSubvDetail(value) {
      this.showSubv = value;
    },
    showCpfDetail() {
      this.showCpf = true;
    },
    cancelCpfDetail(value) {
      this.showCpf = value;
    },
    showPeDetail() {
      this.showPe = true;
    },
    cancelPeDetail(value) {
      this.showPe = value;
    },

    checkCode() {
      if (this.solde - this.code.price < 0) {
        alert("Solde insuffisant pour la prestation code");
      } else if (this.code.ok == 0 && this.code.mode == false) {
        this.code.mode = true;
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "code",
              totalAmount: this.code.price * 100,
              mode: "VIR",
              date: new Date(),
              payeur: "Client",
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.code.mode = false;
            this.checkPaiement();
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.code.ok == 1 && this.code.mode == false) {
        this.code.mode = true;
        window.api
          .delete("/other_paiements/" + this.code.json[0].id, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then(() => {
            this.code.mode = false;
            this.checkPaiement();
          })
          .catch((error) => {
            console.log("ERRR::", error.response.data);
          });
      }
    },

    checkDossier() {
      if (this.solde - this.dossier.price < 0 && this.dossier.ok == 0) {
        alert("Solde insuffisant pour la prestation dossier");
      } else if (this.dossier.ok == 0 && this.dossier.mode == false) {
        this.dossier.mode = true;
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "dossier",
              totalAmount: this.dossier.price * 100,
              mode: "VIR",
              date: new Date(),
              payeur: "Client",
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.dossier.mode = false;
            this.checkPaiement();
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.dossier.ok == 1 && this.dossier.mode == false) {
        this.dossier.mode = true;
        window.api
          .delete("/other_paiements/" + this.dossier.json[0].id, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          })
          .then(() => {
            this.dossier.mode = false;
            this.checkPaiement();
          })
          .catch((error) => {
            console.log("ERRR::", error.response.data);
          });
      }
    },

    showPopupPaiement() {
      this.postPaiement.date = "";
      this.postPaiement.price = "";
      this.postPaiement.mode = "";
      this.postPaiement.payeur = "";
      this.postPaiement.id = "";
      this.popupPaiement = !this.popupPaiement;
    },

    sortDate() {
      if (this.sortDateValue) {
        this.sortDateValue = false;
        this.paiements.sort(
          (a, b) => new Date(b.date.date) - new Date(a.date.date),
        );
      } else {
        this.sortDateValue = true;
        this.paiements.sort(
          (a, b) => new Date(a.date.date) - new Date(b.date.date),
        );
      }
    },

    changeNature() {
      this.paiements = this.allPaiements;
      if (this.tabPaiement.nature != "") {
        this.paiements = this.paiements.filter(
          (p) => p.description == this.tabPaiement.nature,
        );
      }
    },

    changeMode() {
      this.paiements = this.allPaiements;
      if (this.tabPaiement.mode != "") {
        this.paiements = this.paiements.filter(
          (p) => p.mode == this.tabPaiement.mode,
        );
      }
    },

    getSoldes() {
      window.api
        .get("/solde/" + this.data.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.solde = response.data.solde;
          this.rdvSolde = response.data.rdvSolde;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    checkPaiement() {
      window.api
        .get("/eleve/check/paiement/" + this.data.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.dossier = response.data.dossier;
          this.code = response.data.code;
          this.conduite = response.data.conduite;
          this.popupPaiement = false;

          this.droitCpf = response.data.droitCpf;
          this.droitPe = response.data.droitPe;
          this.droitSubv = response.data.droitSubv;

          this.acpteCpf = response.data.acpteCpf;
          this.acptePe = response.data.acptePe;
          this.acpteSubv = response.data.acpteSubv;

          this.paiements = response.data.jsonRes;
          this.paiements.sort(
            (a, b) => new Date(b.date.date) - new Date(a.date.date),
          );

          this.allPaiements = response.data.jsonRes;
          this.allPaiements.sort((a, b) => new Date(b.date) - new Date(a.date));

          this.load = true;
          this.getSoldes();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeSelect() {
      let e = document.getElementById("mode");
      if (e.value == "ESP" || e.value == "CB") {
        this.step = 1;
        this.payeur = "client";
      } else if (e.value == "CHQ" || e.value == "VIR") {
        this.step = 2;
        this.payeur = "";
      } else if (e.value == "CPF" || e.value == "SUBV" || e.value == "PE") {
        this.step = 3;
        this.payeur = "";
      }
    },

    manageSolde() {},

    postPaiements() {
      if (
        !this.postPaiement.date ||
        !this.postPaiement.price ||
        !this.postPaiement.mode ||
        !this.postPaiement.payeur
      ) {
        alert("Veuillez remplir tous les champs avant de valider le paiement");
        return;
      }

      if (
        this.postPaiement.mode == "VIR" &&
        (this.postPaiement.payeur == "PE" || this.postPaiement.payeur == "SUBV") &&
        !this.postPaiement.choix
      ) {
        alert("Veuillez remplir tous les champs avant de valider le paiement");
        return;
      }

      this.loadBtnPaiement = true;
      if (this.postPaiement.mode == "CPF") {
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits CPF",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.changeSoldePlanning(this.postPaiement.price);
            this.checkPaiement();
            this.loadBtnPaiement = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.postPaiement.mode == "PE") {
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits PE",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.changeSoldePlanning(this.postPaiement.price);
            this.checkPaiement();
            this.loadBtnPaiement = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.postPaiement.mode == "SUBV") {
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits SUBV",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.changeSoldePlanning(this.postPaiement.price);
            this.checkPaiement();
            this.loadBtnPaiement = false;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (this.postPaiement.mode == "VIR") {
        if (this.postPaiement.payeur == "CPF") {
          let droit = this.droitCpf.find(
            (e) => e.id == this.postPaiement.choix,
          );
          let montant = droit.tot - this.postPaiement.price;
          if (montant < 0) {
            alert("Votre droit CPF ne peut pas être négatif");
          } else {
            window.api
              .put(
                "/other_paiements/" + droit.id,
                {
                  eleve: "api/utilisateurs/" + this.data.id,
                  description: "Droits CPF",
                  totalAmount: montant * 100,
                  mode: droit.mode,
                  date: droit.date.date,
                  payeur: droit.payeur,
                  archive: false,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                window.api
                  .post(
                    "/other_paiements",
                    {
                      otherPaiementC: "api/other_paiements/" + droit.id,
                      eleve: "api/utilisateurs/" + this.data.id,
                      description: "Acpte CPF",
                      totalAmount: this.postPaiement.price * 100,
                      mode: this.postPaiement.mode,
                      date: this.postPaiement.date,
                      payeur: this.postPaiement.payeur,
                      archive: false,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    },
                  )
                  .then(() => {
                    this.changeSoldePlanning(this.postPaiement.price);
                    this.checkPaiement();
                    this.loadBtnPaiement = false;
                  })
                  .catch((e) => console.log(e));
              })
              .catch((e) => console.log(e));
          }
        } else if (this.postPaiement.payeur == "PE") {
          let droit = this.droitPe.find((e) => e.id == this.postPaiement.choix);
          let montant = droit.tot - this.postPaiement.price;
          if (montant < 0) {
            alert("Votre droit PE ne peut pas être négatif");
            this.loadBtnPaiement = false;
          } else {
            window.api
              .put(
                "/other_paiements/" + droit.id,
                {
                  eleve: "api/utilisateurs/" + this.data.id,
                  description: "Droits PE",
                  totalAmount: montant * 100,
                  mode: droit.mode,
                  date: droit.date.date,
                  payeur: droit.payeur,
                  archive: false,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                window.api
                  .post(
                    "/other_paiements",
                    {
                      otherPaiementC: "api/other_paiements/" + droit.id,
                      eleve: "api/utilisateurs/" + this.data.id,
                      description: "Acpte PE",
                      totalAmount: this.postPaiement.price * 100,
                      mode: this.postPaiement.mode,
                      date: this.postPaiement.date,
                      payeur: this.postPaiement.payeur,
                      archive: false,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    },
                  )
                  .then(() => {
                    this.changeSoldePlanning(this.postPaiement.price);
                    this.checkPaiement();
                    this.loadBtnPaiement = false;
                  })
                  .catch((e) => console.log(e));
              })
              .catch((e) => console.log(e));
          }
        } else if (this.postPaiement.payeur == "SUBV") {
          let droit = this.droitSubv.find(
            (e) => e.id == this.postPaiement.choix,
          );
          let montant = droit.tot - this.postPaiement.price;
          if (montant < 0) {
            alert("Votre droit SUBV ne peut pas être négatif");
            this.loadBtnPaiement = false;
          } else {
            window.api
              .put(
                "/other_paiements/" + droit.id,
                {
                  eleve: "api/utilisateurs/" + this.data.id,
                  description: "Droits SUBV",
                  totalAmount: montant * 100,
                  mode: droit.mode,
                  date: droit.date.date,
                  payeur: droit.payeur,
                  archive: false,
                },
                {
                  headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                  },
                },
              )
              .then(() => {
                window.api
                  .post(
                    "/other_paiements",
                    {
                      otherPaiementC: "api/other_paiements/" + droit.id,
                      eleve: "api/utilisateurs/" + this.data.id,
                      description: "Acpte SUBV",
                      totalAmount: this.postPaiement.price * 100,
                      mode: this.postPaiement.mode,
                      date: this.postPaiement.date,
                      payeur: this.postPaiement.payeur,
                      archive: false,
                    },
                    {
                      headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                      },
                    },
                  )
                  .then(() => {
                    this.changeSoldePlanning(this.postPaiement.price);
                    this.checkPaiement();
                    this.loadBtnPaiement = false;
                  })
                  .catch((e) => console.log(e));
              })
              .catch((e) => console.log(e));
          }
        } else {
          window.api
            .post(
              "/other_paiements",
              {
                eleve: "api/utilisateurs/" + this.data.id,
                description: "paiement",
                totalAmount: this.postPaiement.price * 100,
                mode: this.postPaiement.mode,
                date: this.postPaiement.date,
                payeur: this.postPaiement.payeur,
                archive: false,
              },
              {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              },
            )
            .then(() => {
              this.changeSoldePlanning(this.postPaiement.price);
              this.checkPaiement();
              this.loadBtnPaiement = false;
            })
            .catch((e) => console.log(e));
        }
      } else {
        window.api
          .post(
            "/other_paiements",
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "paiement",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.changeSoldePlanning(this.postPaiement.price);
            this.checkPaiement();
            this.loadBtnPaiement = false;
          })
          .catch((e) => console.log(e));
      }
    },

    putPaiements() {
      if (
        !this.postPaiement.date ||
        !this.postPaiement.price ||
        !this.postPaiement.mode ||
        !this.postPaiement.payeur
      ) {
        alert("Veuillez remplir tous les champs avant de valider le paiement");
        return;
      }

      if (
        this.postPaiement.mode == "VIR" &&
        (this.postPaiement.payeur == "PE" || this.postPaiement.payeur == "SUBV") &&
        !this.postPaiement.choix
      ) {
        alert("Veuillez remplir tous les champs avant de valider le paiement");
        return;
      }

      if (this.postPaiement.mode == "CPF") {
        window.api
          .put(
            "/other_paiements/" + this.postPaiement.id,
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits CPF",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.checkPaiement();
          })
          .catch((e) => console.log(e));
      } else if (this.postPaiement.mode == "PE") {
        window.api
          .put(
            "/other_paiements/" + this.postPaiement.id,
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits PE",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.checkPaiement();
          })
          .catch((e) => console.log(e));
      } else if (this.postPaiement.mode == "SUBV") {
        window.api
          .put(
            "/other_paiements/" + this.postPaiement.id,
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "Droits SUBV",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.checkPaiement();
          })
          .catch((e) => console.log(e));
      } else if (this.postPaiement.mode == "VIR") {
        if (this.postPaiement.payeur == "CPF") {
          let droit = this.droitCpf.find(
            (e) => e.id == this.postPaiement.choix,
          );
          let montant =
            this.postPaiement.montantEdit +
            (droit.tot - this.postPaiement.price);
          if (montant < 0) montant = 0;
          window.api
            .put(
              "/other_paiements/" + droit.id,
              {
                eleve: "api/utilisateurs/" + this.data.id,
                description: "Droits CPF",
                totalAmount: montant * 100,
                mode: droit.mode,
                date: droit.date.date,
                payeur: droit.payeur,
                archive: false,
              },
              {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              },
            )
            .then(() => {
              window.api
                .put(
                  "/other_paiements/" + this.postPaiement.id,
                  {
                    otherPaiementC: "api/other_paiements/" + droit.id,
                    eleve: "api/utilisateurs/" + this.data.id,
                    description: "Acpte CPF",
                    totalAmount: this.postPaiement.price * 100,
                    mode: this.postPaiement.mode,
                    date: this.postPaiement.date,
                    payeur: this.postPaiement.payeur,
                    archive: false,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  },
                )
                .then(() => {
                  this.checkPaiement();
                })
                .catch((e) => console.log(e));
            })
            .catch((e) => console.log(e));
        } else if (this.postPaiement.payeur == "PE") {
          let droit = this.droitPe.find((e) => e.id == this.postPaiement.choix);
          let montant =
            this.postPaiement.montantEdit +
            (droit.tot - this.postPaiement.price);
          if (montant < 0) montant = 0;
          window.api
            .put(
              "/other_paiements/" + droit.id,
              {
                eleve: "api/utilisateurs/" + this.data.id,
                description: "Droits PE",
                totalAmount: montant * 100,
                mode: droit.mode,
                date: droit.date.date,
                payeur: droit.payeur,
                archive: false,
              },
              {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              },
            )
            .then(() => {
              window.api
                .put(
                  "/other_paiements/" + this.postPaiement.id,
                  {
                    otherPaiementC: "api/other_paiements/" + droit.id,
                    eleve: "api/utilisateurs/" + this.data.id,
                    description: "Acpte PE",
                    totalAmount: this.postPaiement.price * 100,
                    mode: this.postPaiement.mode,
                    date: this.postPaiement.date,
                    payeur: this.postPaiement.payeur,
                    archive: false,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  },
                )
                .then(() => {
                  this.checkPaiement();
                })
                .catch((e) => console.log(e));
            })
            .catch((e) => console.log(e));
        } else if (this.postPaiement.payeur == "SUBV") {
          let droit = this.droitSubv.find(
            (e) => e.id == this.postPaiement.choix,
          );
          let montant =
            this.postPaiement.montantEdit +
            (droit.tot - this.postPaiement.price);
          if (montant < 0) montant = 0;
          window.api
            .put(
              "/other_paiements/" + droit.id,
              {
                eleve: "api/utilisateurs/" + this.data.id,
                description: "Droits SUBV",
                totalAmount: montant * 100,
                mode: droit.mode,
                date: droit.date.date,
                payeur: droit.payeur,
                archive: false,
              },
              {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              },
            )
            .then(() => {
              window.api
                .put(
                  "/other_paiements/" + this.postPaiement.id,
                  {
                    otherPaiementC: "api/other_paiements/" + droit.id,
                    eleve: "api/utilisateurs/" + this.data.id,
                    description: "Acpte SUBV",
                    totalAmount: this.postPaiement.price * 100,
                    mode: this.postPaiement.mode,
                    date: this.postPaiement.date,
                    payeur: this.postPaiement.payeur,
                    archive: false,
                  },
                  {
                    headers: {
                      Authorization: "Bearer " + this.$store.state.token,
                    },
                  },
                )
                .then(() => {
                  this.checkPaiement();
                })
                .catch((e) => console.log(e));
            })
            .catch((e) => console.log(e));
        } else {
          window.api
            .put(
              "/other_paiements/" + this.postPaiement.id,
              {
                eleve: "api/utilisateurs/" + this.data.id,
                description: "paiement",
                totalAmount: this.postPaiement.price * 100,
                mode: this.postPaiement.mode,
                date: this.postPaiement.date,
                payeur: this.postPaiement.payeur,
                archive: false,
              },
              {
                headers: { Authorization: "Bearer " + this.$store.state.token },
              },
            )
            .then(() => {
              this.checkPaiement();
            })
            .catch((e) => console.log(e));
        }
      } else {
        window.api
          .put(
            "/other_paiements/" + this.postPaiement.id,
            {
              eleve: "api/utilisateurs/" + this.data.id,
              description: "paiement",
              totalAmount: this.postPaiement.price * 100,
              mode: this.postPaiement.mode,
              date: this.postPaiement.date,
              payeur: this.postPaiement.payeur,
              archive: false,
            },
            { headers: { Authorization: "Bearer " + this.$store.state.token } },
          )
          .then(() => {
            this.checkPaiement();
          })
          .catch((e) => console.log(e));
      }
    },
  },
};
</script>

<style scoped>
/* ===================== VARIABLES ===================== */

.paiement-container {
  --green: #1a9e6e;
  --green-light: #e8f7f1;
  --green-mid: #c3ead9;
  --amber: #f59e0b;
  --amber-light: #fef3c7;
  --blue: #3b82f6;
  --blue-light: #eff6ff;
  --rose: #f43f5e;
  --rose-light: #fff1f2;
  --text: #1a1f2e;
  --text-2: #64748b;
  --text-3: #94a3b8;
  --bg: #f4f6f9;
  --card: #ffffff;
  --border: #e2e8f0;
  --radius: 16px;

  font-family: "DM Sans", sans-serif;
  color: var(--text);
  padding: 24px;

  min-height: 100%;
}

/* ===================== BANDEAU SOLDE ===================== */
.solde-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px 28px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.solde-banner-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.solde-banner-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--text-3);
}

.solde-montant-val {
  font-family: "DM Serif Display", serif;
  font-size: 36px;
  letter-spacing: -1px;
  font-weight: 400;
  transition: color 0.2s;
}
.solde-pos {
  color: var(--green);
}
.solde-neg {
  color: var(--rose);
}

/* ===================== BOUTONS D'ACTION ===================== */
.solde-banner-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.solde-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.solde-action-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none !important;
}

/* Paiement = vert gradient */
.solde-action-pay {
  background: linear-gradient(135deg, var(--blue), #5d81c4);
  color: #fff;
  box-shadow: 0 3px 12px rgba(26, 158, 110, 0.2);
}
.solde-action-pay:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(26, 158, 110, 0.3);
}

/* Dossier = bleu clair (état 0 = primaire) */
.solde-action-dossier {
  background: var(--blue-light);
  color: var(--blue);
  border: 1.5px solid rgba(59, 130, 246, 0.2);
}
.solde-action-dossier:hover:not(:disabled) {
  background: #dbeafe;
}

.dossier-warning {
  background: var(--amber-light) !important;
  color: #b45309 !important;
  border-color: rgba(245, 158, 11, 0.2) !important;
}
.dossier-success {
  background: var(--green-light) !important;
  color: var(--green) !important;
  border-color: rgba(26, 158, 110, 0.2) !important;
}
.dossier-info {
  background: #e0f9ff !important;
  color: #0369a1 !important;
  border-color: rgba(3, 105, 161, 0.2) !important;
}

/* Code = ambre */
.solde-action-code {
  background: var(--amber-light);
  color: #b45309;
  border: 1.5px solid rgba(245, 158, 11, 0.2);
}
.solde-action-code:hover:not(:disabled) {
  background: #fde68a;
}

.code-warning {
  background: var(--amber-light) !important;
  color: #b45309 !important;
}
.code-success {
  background: var(--green-light) !important;
  color: var(--green) !important;
  border-color: rgba(26, 158, 110, 0.2) !important;
}
.code-info {
  background: #e0f9ff !important;
  color: #0369a1 !important;
  border-color: rgba(3, 105, 161, 0.2) !important;
}

/* CPF / PE / SUBV */
.solde-action-cpf {
  background: #f5f3ff;
  color: #5b21b6;
  border: 1.5px solid rgba(139, 92, 246, 0.2);
}
.solde-action-cpf:hover {
  background: #ede9fe;
}

/* ===================== TOOLTIP ===================== */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-div {
  visibility: hidden;
  width: max-content;
  max-width: 320px;
  background: #1e293b;
  color: #fff;
  text-align: left;
  padding: 10px 14px;
  border-radius: 10px;
  position: absolute;
  z-index: 100;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.18s;
  pointer-events: none;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.tooltip-container:hover .tooltip-div {
  visibility: visible;
  opacity: 1;
}

.btnColor {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 12px;
}
.btnColor:last-child {
  margin-bottom: 0;
}
.btnColor p {
  margin: 0;
  line-height: 1.4;
}

.squareColorPrimary {
  background: #3b82f6;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}
.squareColorWarning {
  background: #f59e0b;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}
.squareColorSuccess {
  background: #1a9e6e;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}
.squareColorInfo {
  background: #38bdf8;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  flex-shrink: 0;
}

/* ===================== TABLEAU ===================== */
.table-wrap {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  overflow-x: auto;
  overflow-y: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  -webkit-overflow-scrolling: touch;
}

.table-wrap--modal {
  max-height: 48vh;
  overflow-y: auto;
}

table#paiement {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-family: "DM Sans", sans-serif;
}

/* Thead vert */
.solde-thead {
  background: linear-gradient(135deg, var(--blue), #5d81c4);
}

.solde-th {
  padding: 14px 18px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  border-bottom: none;
  white-space: nowrap;
  vertical-align: middle;
}

.solde-th-icon {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

/* Bouton tri dans le header */
.btn-sort {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-family: "DM Sans", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  cursor: pointer;
  padding: 0;
}
.btn-sort:hover {
  color: #fff;
}

/* Select dans le header */
.select-th {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-family: "DM Sans", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  padding: 0;
}
.select-th option {
  color: var(--text);
  background: #fff;
  font-size: 13px;
  text-transform: none;
  letter-spacing: 0;
}

/* Lignes */
table#paiement tbody tr {
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.1s;
}
table#paiement tbody tr:last-child {
  border-bottom: none;
}
table#paiement tbody tr:hover {
  background: #f8fafc;
}

.row-conduite {
  background: var(--bg) !important;
  cursor: default !important;
}
.row-conduite:hover {
  background: var(--bg) !important;
}

.solde-td {
  padding: 13px 18px;
  font-size: 13px;
  color: var(--text);
  vertical-align: middle;
}

.date-col {
  color: var(--text-2);
  font-size: 12px;
}

.solde-credit {
  font-weight: 700;
  color: var(--green);
}
.solde-debit {
  font-weight: 600;
  color: var(--rose);
}

/* Badge mode de paiement */
.mode-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  background: var(--blue-light);
  color: var(--blue);
}

/* ===================== MODAL FIELDS ===================== */
.modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 8px 0;
}

.pay-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pay-modal-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: var(--text-3);
}

.pay-modal-input,
.pay-modal-select {
  padding: 10px 14px;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  color: var(--text);
  background: var(--bg);
  outline: none;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  width: 100%;
  background-color: #f4f6f9;
}
.pay-modal-input:focus,
.pay-modal-select:focus {
  border-color: var(--green);
  box-shadow: 0 0 0 3px rgba(26, 158, 110, 0.1);
  background: #fff;
}
.pay-modal-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Footer du dialog */
.modal-footer-btns {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.btn-pay-modal {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 11px 22px;
  background: linear-gradient(135deg, var(--green), #0d7a54);
  color: #98dfc0;
  font-family: "DM Sans", sans-serif;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s;
  box-shadow: 0 4px 16px rgba(26, 158, 110, 0.2);
}
.btn-pay-modal:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(26, 158, 110, 0.3);
}

.btn-pay-edit {
  background: linear-gradient(135deg, var(--blue), #2563eb);
  color: #2563eb;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.2);
}
.btn-pay-edit:hover {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
}

.btn-pay-delete {
  background: linear-gradient(135deg, var(--rose), #e11d48);
  color: #e11d48;
  box-shadow: 0 4px 16px rgba(244, 63, 94, 0.2);
}
.btn-pay-delete:hover {
  box-shadow: 0 6px 20px rgba(244, 63, 94, 0.3);
}

/* ===================== LOADING ===================== */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 0;
  color: var(--text-2);
  font-size: 14px;
}

.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border);
  border-top-color: var(--green);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===================== RESPONSIVE ===================== */
@media (max-width: 768px) {
  .paiement-container {
    padding: 16px;
  }
  .solde-banner {
    flex-direction: column;
    align-items: flex-start;
  }
  .modal-grid {
    grid-template-columns: 1fr;
  }
  .solde-montant-val {
    font-size: 28px;
  }
}
</style>
